@if (data) {
  <section class="text-value">
    <app-emu-input
      data-cy="dashboard-text-value"
      name="{{ 'DASHBOARD.TEXT_VALUE' | translate }}"
      [className]="'dashboard-settings'"
      [(value)]="data.text"
      [textArea]="true"
    ></app-emu-input>
  </section>
  <section class="text-value">
    <app-emu-input
      data-cy="dashboard-url-link"
      name="{{ 'DASHBOARD.URL_LINK' | translate }}"
      [className]="'dashboard-settings'"
      [(value)]="data.url"
      [placeholder]="'FIELD.OPTIONAL'"
      [maxLength]="128"
    ></app-emu-input>
  </section>
  <section class="flex-in-row">
    <mat-checkbox [(ngModel)]="data.autoSize" data-cy="dashboard-auto-size">
      {{ 'DASHBOARD.AUTO_SIZE' | translate }}
    </mat-checkbox>
    <!--      [class.hide]="data.autoSize"-->
    <app-emu-list-input
      data-cy="dashboard-text-size"
      [disabled]="data.autoSize"
      [(value)]="data.size"
      [name]="'DASHBOARD.TEXT_SIZE'"
      [className]="'dashboard-settings'"
      [filteredOptions$]="of(fontSizeList)"
      [clearButtonHidden]="true"
    >
      <ng-template let-item
        ><p>{{ item }} px</p></ng-template
      >
    </app-emu-list-input>
  </section>
  <section class="flex-in-row">
    <span class="no-wrap color-label">{{ 'DASHBOARD.TEXT_COLOR' | translate }}</span>
    <app-emu-color-input
      [(color)]="data.color"
      data-cy="dashboard-input-color"
    ></app-emu-color-input>
  </section>
  <section class="text-align">
    <button
      data-cy="dashboard-left-align-button"
      class="dashboard-button"
      [class.selected]="data.align === 'left'"
      (click)="setAlignment('left')"
    >
      <mat-icon svgIcon="align-left"></mat-icon>
    </button>
    <button
      data-cy="dashboard-center-align-button"
      class="dashboard-button"
      [class.selected]="data.align === 'center'"
      (click)="setAlignment('center')"
    >
      <mat-icon svgIcon="align-center"></mat-icon>
    </button>
    <button
      data-cy="dashboard-right-align-button"
      class="dashboard-button"
      [class.selected]="data.align === 'right'"
      (click)="setAlignment('right')"
    >
      <mat-icon svgIcon="align-right"></mat-icon>
    </button>
  </section>
  <section class="flex-in-row">
    <mat-checkbox
      [(ngModel)]="item.styles.showBackground"
      data-cy="dashboard-show-background"
      class="no-wrap"
    >
      {{ 'DASHBOARD.SHOW_BACKGROUND' | translate }}
    </mat-checkbox>
  </section>
  <section class="flex-in-row">
    <span class="no-wrap color-label" [class.disabled]="!item.styles.showBackground">
      {{ 'DASHBOARD.BACKGROUND_COLOR' | translate }}
    </span>
    <app-emu-color-input
      data-cy="dashboard-background-color"
      [disabled]="!item.styles.showBackground"
      [(color)]="item.styles.background"
    ></app-emu-color-input>
  </section>
}
